import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { TotalsType } from 'Type/MiniCart.type';
import {
    getCartShippingPrice,
    getCartShippingSubPrice,
    getCartSubtotal,
    getCartSubtotalSubPrice,
    getCartTotalSubPrice
} from 'Util/Cart';

import FreeShippingNotification from './FreeShippingNotification.component';

/** @namespace Bodypwa/Component/FreeShippingNotification/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    totals: state.CartReducer.cartTotals,
    cartDisplayConfig: state.ConfigReducer.cartDisplayConfig,
    cartSubtotal: getCartSubtotal(state),
    cartSubtotalSubPrice: getCartSubtotalSubPrice(state),
    cartTotalSubPrice: getCartTotalSubPrice(state),
    cartShippingPrice: getCartShippingPrice(state),
    cartShippingSubPrice: getCartShippingSubPrice(state),
    freeShippingThreshold: state.ConfigReducer.free_shipping_threshold
});

/** @namespace Bodypwa/Component/FreeShippingNotification/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace Bodypwa/Component/FreeShippingNotification/Container */
export class FreeShippingNotificationContainer extends PureComponent {
    static propTypes = {
        totals: TotalsType.isRequired,
        freeShippingThreshold: PropTypes.string.isRequired
    };

    containerProps() {
        const {
            totals,
            freeShippingThreshold
        } = this.props;

        return {
            totals,
            freeShippingThreshold
        };
    }

    render() {
        return (
            <FreeShippingNotification
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FreeShippingNotificationContainer);
